/* eslint-disable no-template-curly-in-string */
import commons from "./commons/vi"
import components from "./components/vi"
import forms from "./forms/vi"
import models from "./models/vi"
import screens from "./screens/vi"
import yup from "./yup/vi"

export default {
  "bottomMenu" : {
    "home": "Nhà",
    "graph": "Đồ thị",
    "quickInput": "Nhập nhanh",
    "help": "Cứu giúp",
    "profile": "Hồ sơ"
  },
  "common": {
    "ok": "Được!",
    "yes": "Vâng",
    "cancel": "Hủy bỏ",
    "back": "Quay lại",
    "close": "Gần",
    "next": "Tiếp Theo",
    "done": "Xong",
  },
  "errors": {
    "invalidEmail": "địa chỉ email không hợp lệ."
  },
  "welcomeScreen": {
    "poweredBy": "POWERED BY IGNITE",
    "readyForLaunch": "Ready for launch.",
    "continue": "CONTINUE"
  },
  "demoScreen": {
    "howTo": "HOW TO",
    "title": "What’s In This Stack?",
    "tagLine": "Congratulations, you’ve got a very advanced React Native app template here.  Take advantage of this boilerplate!",
    "reactotron": "Demo Reactotron",
    "demoList": "Demo List",
    "androidReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running, run adb reverse tcp:9090 tcp:9090 from your terminal, and reload the app.",
    "iosReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app.",
    "macosReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app.",
    "webReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app.",
    "windowsReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app."
  },
  "demoListScreen": {
    "title": "Demo List"
  },
  "errorScreen": {
    "title": "Something went wrong!",
    "friendlySubtitle": "This is the screen that your users will see in production when an error is thrown. You'll want to customize this message (located in `app/i18n/en.json`) and probably the layout as well (`app/screens/error`). If you want to remove this entirely, check `app/app.tsx` for the <ErrorBoundary> component.",
    "traceTitle": "Error from %{name} stack",
    "reset": "RESET APP"
  },

  "splashScreen": {
    "splashScreenTitle": "Ứng dụng quản lý trang trại nuôi tôm",
    "releaseTitle": "Có gì mới trong {{version}}",
    "releaseMessage": "",
    "hashtag": "#HadirMembantu"
  },
  "onboardScreen": {
    "onboard1": "Chào mừng đến với Jala",
    "onboard2": "Chế độ ngoại tuyến",
    "onboard3": "Theo dõi tình trạng ao nuôi mọi lúc mọi nơi",
    "onboard4": "Đồng quản lý trại nuôi",
    "onboard5": "Cập nhật giá tôm và các tin tức mới nhất",
    "onboard6": "Tích hợp với thiết bị đo chất lượng nước Jala Baruno.",
    "login": "Đăng nhập",
    "register": "Đăng ký",
    "justTry": "Chỉ muốn thử?",
    "tryDemo": "Dùng thử bản demo"
  },
  "socialLoginScreen": {
    "socialLoginScreenTitle": "Ứng dụng công nghệ quản lý nuôi tôm",
    "loginWithApple": "Đăng nhập với Apple",
    "loginWithGoogle": "Đăng nhập với Google",
    "loginWithFacebook": "Đăng nhập Facebook",
    "or": "Hoặc",
    "loginWithEmail": "Đăng nhập bằng Email của bạn",
    "loginWithPhoneEmail": "Ký bằng số điện thoại hoặc Email"
  },
  "loginScreen": {
    "welcome": "Chào mừng",
    "loginSubtitle": "Vui lòng đăng nhập bằng địa chỉ email đã đăng ký",
    "email": "Email",
    "emailAddress": "Số điện thoại hoặc địa chỉ email",
    "password": "Mật khẩu",
    "forgotPassword": "Quên mật khẩu?",
    "login": "Đăng nhập",
    "failedAlert": "Đăng nhập thất bại",
    "failedAlertSubtitle": "Đảm bảo Số điện thoại/Email và Mật khẩu của bạn là chính xác"
  },
  "passwordResetScreen": {
    "resetPassword": "Đặt lại mật khẩu",
    "forgotPassword": "Quên mật khẩu",
    "InputForgotPasswordEmail": "Nhập email của bạn",
    "ButtonForgotPassword": "Gửi liên kết đặt lại mật khẩu",
    "forgotPasswordSubtitle": "Nhập địa chỉ email của bạn, chúng tôi sẽ gửi cho bạn hướng dẫn với liên kết đặt lại mật khẩu.",
    "guideTitle": "Hướng dẫn đặt lại đã được gửi",
    "guideMessage": "kiểm tra email của bạn để đặt lại mật khẩu.",
    "failedTitle": "Đặt lại mật khẩu không thành công",
    "errorMessage": "Chúng tôi không thể tìm thấy người dùng có những email đó",

    "phoneModeButton": "Sử dụng Số Điện Thoại",
    "emailModeButton": "Sử dụng Email",
    "sendOTPButton": "Gửi Mã Xác Minh",

    "forgotPasswordWithPhoneSubtitle": "Nhập số điện thoại của bạn, chúng tôi sẽ gửi mã xác minh để đặt lại mật khẩu.",
    "inputOTPTitle": "Nhập mã xác minh",
    "inputOTPSubtitle": "Mã xác minh đã được gửi đến số điện thoại {{phone}}. Vui lòng nhập mã xác minh bên dưới để tiếp tục. Không nhận được mã xác minh?",
    "resendOTP": "Gửi lại mã",
    "inputNewPassword": "Nhập mật khẩu mới của bạn",
    "successTitle": "Cập Nhật Mật Khẩu Thành Công",
    "successSubtitle": "Mật khẩu của bạn đã được cập nhật thành công. Bây giờ bạn có thể đăng nhập lại bằng mật khẩu mới của bạn.",

    "sendWhatsappVerification": "Gửi Mã Xác Minh Qua WhatsApp",
    "sendSMSVerification": "Gửi Mã Xác Minh Qua Tin Nhắn",

    "modalTitleSuccess": "Gửi lại mã thành công",
    "modalSubtitleSuccess": "Bạn có thể yêu cầu mã OTP hai lần mỗi ngày. Nếu bạn vượt quá giới hạn, vui lòng thử lại vào ngày mai. Cảm ơn bạn đã sử dụng dịch vụ của chúng tôi.",
    "modalTitleFailed": "Giới Hạn Gửi Mã",
    "modalSubtitleFailed": "Bạn đã đạt đến giới hạn yêu cầu mã OTP của bạn cho hôm nay. Vui lòng thử lại vào ngày mai để nhận mã OTP mới hoặc Liên hệ chúng tôi."
  },
  "registerScreen": {
    "register": "Đăng ký",

    "subPatent": "Bằng cách đăng ký Jala, bạn đồng ý ",
    "jalaPrivacyAndPolicy": "Điều khoản dịch vụ và Chính sách quyền riêng tư của JALA đối với",
    "registerNow": "Đăng ký ngay",
    "phoneDisclaimer": "Đảm bảo số điện thoại bạn nhập là chính xác, vì bạn chỉ có thể thay đổi số điện thoại một lần trong 24 giờ."
  },
  "initialSyncScreen": {
    "loading": "Vui lòng chờ\tải dữ liệu..."
  },

  "registerForm": {
    "name": "Họ và tên",
    "phone": "Số điện thoại",
    "email": "Email",
    "password": "Mật khẩu",
    "passwordConfirmation": "Xác nhận mật khẩu",
    "type": "Nghề nghiệp",
    "occupation": "BẰNG",
    "birthdate": "Ngày sinh",
    "knowjalafrom": "Bạn biết về JALA từ đâu?",

    "namePlaceholder": "Họ và tên",
    "phonePlaceholder": " ",
    "emailPlaceholder": "Email",
    "passwordPlaceholder": "Mật khẩu",
    "passwordConfirmationPlaceholder": "Xác nhận mật khẩu",
    "farmers": "Nông dân",
    "nonFarmers": "phi nông dân",
    "occupationPlaceholder": "Chọn",
    "birthdatePlaceholder": "Chọn",

    "passwordConfirmationDoesntMatch": "${path} không khớp",

    "social_media": "Mạng xã hội (Facebook, Instagram, TikTok, Youtube)",
    "online_ads": "Quảng cáo trực tuyến",
    "blog_or_article": "Blog/Bài báo",
    "offline_attribute": "Thuộc tính ngoại tuyến (Tờ rơi, danh mục, Biểu ngữ)",
    "friend_recomendation": "giới thiệu bạn bè",
    "community": "Cộng đồng",
    "online_event": "Sự kiện trực tuyến",
    "offline_event": "Sự kiện ngoại tuyến",
    "other": "Khác"
  },

  "profileScreen": {
    "profile": "Hồ sơ",
    "verified": "Đã xác minh",
    "unverified": "Chưa được xác minh",
    "editProfile": "Chỉnh sửa hồ sơ",
    "farmProfile": "Trại nuôi kết nối",
    "security": "Bảo vệ",
    "settingAccount": "Cài đặt",
    "privacyMenu": "Chính sách bảo mật",
    "choice": "Sự lựa chọn",
    "interesTitle": "Cài đặt riêng",
    "language": "Ngôn ngữ",
    "support": "Trợ giúp",
    "helpMenu": "Trợ giúp",
    "faq": "FAQ",
    "whatsapp": "Jala WhatsApp",
    "emailMenu": "Email",
    "appsTutorial": "Hướng dẫn ứng dụng Jala",
    "joinTelegram": "Tham gia nhóm Telegram",
    "theOther": "Người khác",
    "rateUs": "Xếp hạng Jala",
    "appInfo": "Thông tin ứng dụng",
    "exitMenu": "Thoát",
    "changeLanguage": "thay đổi ngôn ngữ",
    "messenger": "tin nhắn Facebook",
    "logoutTitle": "Kiểm tra trước khi Đăng xuất",
    "logoutSubtitle": "Đảm bảo dữ liệu ngoại tuyến là '0' trước khi thoát ứng dụng. Dữ liệu ngoại tuyến chưa được tải lên có thể bị xóa nếu bạn đăng xuất",
    "logoutButtonConfirm": "Đăng xuất",
    "logoutButtonCancel": "Mặt sau"
  },

  "settingAccount": {
    "setting": "Cài đặt",
    "changePassword": "Đổi mật khẩu",
    "delete": "Xóa tài khoản",
    "resetOfflineDatabase": "Đặt lại cơ sở dữ liệu ngoại tuyến",
    "resetOfflineDatabaseWarn": "Bạn sẽ mất các bản ghi ngoại tuyến chưa được gửi.",
  },

  "changePasswordForm": {
    "currentPassword": "Mật khẩu cũ",
    "password": "Mật khẩu mới",
    "passwordConfirmation": "Gõ lại mật khẩu mới",
    "success": "Mật khẩu đã được thay đổi thành công",
    "oldPasswordError": "Mật khẩu hiện tại không khớp",
    "failedInput": "Không thành công, vui lòng thử lại",

    "currentPasswordPlaceholder": "Mật khẩu cũ",
    "passwordPlaceholder": "Mật khẩu mới",
    "passwordConfirmationPlaceholder": "Gõ lại mật khẩu mới",

    "passwordConfirmationDoesntMatch": "${path} không khớp"
  },

  "deleteScreen": {
    "term1": "Chu kỳ dữ liệu, ao và trang trại sẽ bị xóa và bạn không thể truy cập lại.",
    "term2": "Tài khoản và dữ liệu cá nhân của bạn sẽ bị xóa.",
    "term3": "Bạn sẽ không còn kết nối với trang trại khác.",
    "deletingAccount": "Bạn có chắc chắn muốn xóa tài khoản này không?",
    "termDelete": "Nếu tài khoản của bạn bị xóa : ",
    "delete": "Xóa",
    "deleteConfirm": "Xác nhận mật khẩu",
    "agreement": "Tôi hiểu và chấp nhận mọi rủi ro ở trên về việc xóa tài khoản.",
    "disclaimer": "Không thể khôi phục lại tài khoản đã xóa. Nếu bạn chắc chắn, vui lòng điền mật khẩu của bạn để xóa tài khoản.",
    "placeholder": "Xác nhận mật khẩu"
  },

  "editProfileForm": {
    "header": "Thay đổi tài liệu",
    "photo": "Thay đổi hồ sơ ảnh",
    "name": "Họ và tên",
    "email": "E-mail",
    "phone": "Số điện thoại",
    "gender": "Giới tính",
    "regionId": "Địa chỉ nhà",
    "save": "Tiết kiệm",
    "man": "Người đàn ông",
    "woman": "Người đàn bà",
    "takePhoto": "Chụp ảnh",
    "fromGallery": "Từ thư viện",

    "namePlaceholder": "Họ và tên",
    "emailPlaceholder": "Địa chỉ email",
    "phonePlaceholder": "Số điện thoại",
    "genderPlaceholder": "Chọn giới tính",
    "regionIdPlaceholder": "Chọn Địa chỉ nhà"
  },

  "connectedFarm": {
    "header": "Trại nuôi kết nối",
    "as": "Đối tượng",
    "member": "Thành viên",
    "emptyTitle": "Chưa có trại nuôi nào",
    "emptySubtitle": "Tạo trại nuôi của bạn hoặc yêu cầu chủ trại mời bạn.",
    "farmProfile": "Hồ sơ trại nuôi",
    "farmLabel": "Tên trại nuôi",
    "address": "Địa chỉ",
    "area":"Khu vực",
    "addMember": "Thêm thành viên",
    "owner": "Chủ sở hữu/ Người quản lý",
    "operator": "Người vận hành",
    "viewer": "Khách hoặc người xem",
    "admin": "Quản trị viên",
    "laboran": "Trợ lý phòng thí nghiệm",
    "add": "Thêm thành viên",
    "roleId": "Đối tượng",
    "roleIdPlaceholder": "Chọn vai trò",
    "info": "Thông tin",
    "access1": "Điều chỉnh dữ liệu trại nuôi",
    "access2": "Xem dữ liệu trại nuôi",
    "access3": "Truy cập biểu đồ phân tích (ứng dụng web)",
    "access4": "Xem và điều chỉnh dữ liệu kiểm kê hoạt động trại nuôi(ứng dụng web)",
    "access5": "Xuất báo cáo hoạt động trại nuôi (ứng dụng web)",
    "access6": "Xem và điều chỉnh dữ liệu tài chính trại nuôi (ứng dụng web)",
    "access7": "Xuất báo cáo tài chính trại nuôi (ứng dụng web)",
    "access8": "Thêm và xóa thành viên",
    "access9": "Điều chỉnh quyền truy cập của thành viên",
    "changeAccess": "Điều chỉnh",
  },

  "pondScreen": {
    "addFarm": "Tạo Trại nuôi",
    "emptyFarm": "Không trại nuôi nào",
    "createPond": "Tạo ao",
    "addPond": "Thêm ao",
    "emptyPond": "Chưa có ao nào",
    "startCycle": "Bắt đầu chu kỳ",
    "cycleHistory": "Lịch sử chu kỳ",
    "ClosedAt": "Đã kết thúc vào",
    "age": "Ngày tuổi",
    "temperature": "nhiệt độ",
    "do": "DO",
    "ph": "pH",
    "salinity": "độ mặn",
    "weather": "thời tiết",
    "color": "màu sắc"
  },

  "storybook": {
    "placeholder": "Placeholder",
    "field": "Field"
  },

  "graphScreen": {
    "header": "Biểu đồ",
    "message": "Chọn trước các trại nuôi,\nao nuôi và chu kỳ để hiển thị biểu đồ ",
    "farming": "Nông nghiệp",
    "waterQuality": "Chất lượng nước",
    "costAnalysis": "Phí tổn",


    "profitPotential": "Tiềm năng Lợi nhuận",
    "productionCost": "Ước tính giá vốn hàng bán ({{currency}}/kg)",
    "incomePotential": "Tiềm năng Thu nhập",
    "estimationFeedCost": "Chi phí ăn uống",
    "estimatedSellingPrice": "Ước tính giá bán",
    "production": "Ước tính chi phí sản xuất",
    "active": "Chu kỳ Hoạt động",
    "nonactive": "Chu kỳ Không Hoạt động",
    "revenuePotentialDisclaimer": "Potencial doanh thu = ước tính lượng sinh khối x giá bán tôm + mùa thu trước ({{currency}})",
    "profitPotentialDisclaimer": "Potencial lợi nhuận = potencial doanh thu - tổng chi phí ước tính",
    "profitPotntialDisclaimerSubtitle": "Chi phí tổng cộng ước tính được thông qua phương pháp tính chi phí thức ăn là khoản đóng góp lớn nhất + các ước tính chi phí khác.",
    "hppEstimation": "Ước tính HPP = ",
    "costEstimation": "chi phí sản xuất ước tính ({{currency}})",
    "biomassEstimation": "ước tính sinh khối + mùa thu (kg)",
    "hppEstimationDisclaimer": "Chi phí tổng cộng ước tính được thông qua phương pháp tính chi phí thức ăn là khoản đóng góp lớn nhất + các ước tính chi phí khác.",
    "productionDisclaimer": "Chi phí sản xuất = chi phí giống + chi phí thức ăn + ước tính chi phí khác",
    "sellingPriceDisclaimer": "Giá bán = ước tính sinh khối x giá tính từ ước tính giá vốn hàng bán",
    "sellingPriceDisclaimer2": "*Tính toán dự đoán chi phí này không bao gồm tiền điện, lương nhân viên và chi phí chuẩn bị trồng trọt.",
    "completeDataDisclaimer": "Hoàn thành dữ liệu nguồn cấp dữ liệu của bạn để có được ước tính chính xác hơn",
    "feedCostDisclaimer": "Chi phí thức ăn = tổng lượng thức ăn x giá thức ăn",
    "cogsDisclaimer1": "*<b>Tiền điện</b>, <b>lương nhân viên</b> and <b>chi phí chuẩn bị trồng trọt</b> không được đưa vào tính toán ước tính.",
    "cogsDisclaimer2": "*Giá trị ước tính này chỉ là thông tin thay thế để đánh giá các khía cạnh vận hành của hoạt động trồng trọt.",
  },

  "diseaseScreen": {
    "shrimpDisease": "Bệnh tôm",
    "diseaseSearchPlaceholder": "Tìm kiếm từ khóa bệnh",
    "listDisease": "Liệt kê bệnh",
    "read": "Đọc",
    "empty": "Rất tiếc, không tìm thấy kết quả.\nSử dụng từ khóa khác",
    "mostSearch": "hoặc xem bệnh được tìm kiếm nhiều nhất"
  },

  "newsScreen": {
    "shrimpNews": "Tin tôm",
    "newsSearchPlaceholder": "Tìm kiếm tin tức về tôm",
    "latestNews": "Tin mới nhất",
    "allCategory": "Tất cả các loại",
    "other": "Xem những người khác",
    "search": "Kết quả tìm kiếm từ '{{search}}'",
    "searchByCategory": "hoặc tìm kiếm theo danh mục",
    "category": "Loại"
  },

  "autoFeederScreen": {
    "title": "tự động nạp",

    "connect": "chấp nối",
    "mode": "âm pháp",
    "typeCommand": "Gõ lệnh",
    "send": "Gửi",
    "failedToConnect": "Kết nối thất bại"
  },

  "autoFeederPondCreateScreen": {
    "title": "Thêm khay nạp tự động",
    "successAddSubtitle": "Asto của bạn đã được thêm thành công!",
    "successModalSubtitle": "Trước khi sử dụng Asto, điều quan trọng là phải định cấu hình kết nối, chế độ phát và chạy thử"
  },

  "autofeederCreateQRScanScreen": {
    "title": "Quét mã QR",
    "description": "Hướng camera vào hình ảnh mã qr được in trên bộ điều khiển asto",
    "unrecognizedModalTitle": "mã QR không được nhận dạng",
    "unrecognizedModalSubtitle": "Mã QR chưa được đăng ký trong cơ sở dữ liệu của chúng tôi, vui lòng thử quét lại."
  },

   "autoFeederPondCreateWizardScreen": {
    "connectionSetup": "Thiết lập Kết nối",
    "modeSetup": "Thiết lập Chế độ",
    "testRunSetup": "Chạy Thử Asto",
    "connectAsto": "Kết nối Asto",
    "connectAstoSubtitle": "Khi vận hành Asto, bạn cần kết nối Asto thông qua mạng Bluetooth hoặc Wifi",
    "connectAstoWifi": "Kết nối Asto qua Wifi (tùy chọn)",
    "connectAstoWifiSubtitle": "Bạn cũng có thể kết nối Asto với mạng wifi trong ao nuôi",
    "testRunSubtitle": "Kiểm tra bộ điều khiển Asto, đảm bảo nó đã kết nối với bộ tự động cho ăn của bạn",
    "testRunModalTitle": "Bộ tự động cho ăn đã hoạt động chưa?",
    "hold": "Giữ để bắt đầu",
    "bluetooth": "Bluetooth",
    "bluetoothDisconnected": "Đã Ngắt kết nối. Chạm để kết nối",
    "ssid": "Tên mạng WiFi (SSID)",
    "password": "Mật khẩu WiFi",
    "connect": "Kết nối",
    "optional": "*Bạn có thể bỏ qua giai đoạn này",
    "modeSetupSubtitle": "Chọn một trong các chế độ tương ứng với điều kiện hiện tại trong ao của bạn",
    "normal": "Bình thường",
    "normalDescription": "Cho ăn theo lịch trình cố định trong một ngày",
    "continue": "Tiếp tục",
    "continueDescription": "Cho ăn liên tục cho đến khi kết thúc thời gian cho ăn",
    "timesPerDay": "Tổng số lần cho ăn",
    "debit": "Lượng Thức Ăn",
    "intervalPeriod": "Thời gian Cho ăn",
    "onTime": "Thời gian Bật",
    "interval": "Khoảng Thời gian",
    "startTime": "Thời gian Bắt đầu",
    "endTime": "Thời gian Kết thúc",
    "debitUnit": "gr/giây",
    "intervalPeriodUnit": "phút",
    "onTimeUnit": "giây",
    "timesPerDayUnit": "lần/ngày",
    "debitError": "Lượng thức ăn tối thiểu trong một ngày là 5 và tối đa là 7",
    "intervalHelper": "Khoảng thời gian theo hệ thống",
    "onHelper": "Thời gian bật theo hệ thống",
    "timerOnInfo": "Thời gian quay một vòng của động cơ",
    "successModalTitle": "Chúc mừng bạn đã hoàn thành cấu hình Asto",
    "successModalSubtitle": "Tiếp theo, bạn sẽ được đưa đến làm quen với các chức năng của tính năng Asto",
    "infoTestRun": "Test Run sẽ được thực hiện theo kế hoạch ",
    "throwingDistance": "Khoảng cách ném",
    "infoTestRunOnTime": "Timer ON: {{onTime}} giây",
    "short": "Ngắn",
    "medium": "Trung bình",
    "long": "Dài",
    "manual": "Đặt thời gian quay (thủ công)",
    "duration": "Thời lượng vòng",
    "timesPerDayHelper": "Bạn có thể sạc từ 1 đến 7 lần/ngày",
    "distanceHelper": "Khoảng cách phát thức ăn phụ thuộc vào kích thước thức ăn."
  },

  "autoFeederPondDetailScreen": {
    "title": "Chi tiết Asto",

    "mode": "âm pháp",
    "debit": "Nguồn cấp dữ liệu ghi nợ",
    "throwDebit": "Nguồn cấp dữ liệu ghi nợ",
    "startTime": "Thời gian bắt đầu",
    "endTime": "Thời gian kết thúc",
    "onTime": "Hẹn giờ BẬT",
    "timesPerDay": "Nguồn cấp dữ liệu mỗi ngày",
    "timesPerPeriod": "Ném mỗi lần cho ăn",
    "intervalPerPeriod": "Khoảng thời gian ném",
    "intervalPeriod": "Thời lượng nguồn cấp dữ liệu",
    "duration": "Khoảng thời gian",
    "frequency": "Tính thường xuyên",
    "quantity": "Cho ăn",
    "interval": "Khoảng thời gian hẹn giờ",
    "onTimeOverride": "Hẹn giờ thủ công BẬT",
    "intervalOverride": "Khoảng thời gian hẹn giờ thủ công",
    "lastOnAt": "BẬT lần cuối",
    "previousOnAt": "Trước BẬT",
    "nextOnAt": "BẬT tiếp theo",

    "intervalShort": "khoảng thời gian",
    "override": "Thủ công",

    "debitUnit": "gr/s",
    "throwDebitUnit": "gr/throw",
    "onTimeUnit": "s",
    "timesPerDayUnit": "lần",
    "timesPerPeriodUnit": "lần",
    "intervalUnit": "phút(s)",
    "intervalPeriodUnit": "phút(s)",

    "intervalUnitShort": "m",

    "today": "Hôm nay",
    "nextDay": "Ngày tiếp theo",
    "date": "Ngày tháng",
    "time": "lần",

    "feedData": "Cycle Feed Data",
    "openFeedData": "Open Feed Data",
    "setFeedData": "Use Feed Data",

    "portion": "Portion (kg)",
    "feedPortion": "Feed Portion",
    "feedPortionHelper": "Feed Portion 1 of %{total} Auto Feeder",

    "failedToConnect": "Kết nối thất bại",
    "uploadOrResetFirst": "Tải lên hoặc đặt lại trước",

    "normal": "Bình thường",
    "continuous": "Tiếp diễn",

    "feedTableTitle": "Bảng nguồn cấp dữ liệu",
    "feedCycleTitle": "Dữ liệu nguồn cấp chu kỳ",
    "todayFeedTitle": "nguồn cấp dữ liệu hôm nay",

    "weeklySchedule": "Lịch ăn hàng tuần",
    "detail": "Chi tiết(kg)",
    "detailInfo": "Chi tiết phụ thuộc vào thời gian nạp",
    "intervalInfo": "Khoảng thời gian giữa các vòng",
    "durationInfo": "Thời gian hoạt động của động cơ mỗi lần quay",

    "feedCycleDataDescription": "Bạn có thể sử dụng dữ liệu nguồn cấp dữ liệu đã được nhập trong tính năng Nhập nguồn cấp dữ liệu",
    "disconnectedWarning": "Kết nối bị mất",
    "disconnectedWarningDescription": "Bạn không được kết nối với Asto",

    "confirmationSaveTitle": "Lưu dữ liệu?",
    "confirmationSaveSubtitle": "Bạn có chắc chắn muốn lưu dữ liệu?",
    "confirmationUploadTitle": "Tải dữ liệu lên?",
    "confirmationUploadSubtitle": "Bạn có chắc chắn muốn tải dữ liệu lên?",
    "confirmationResetTitle": "Đặt lại dữ liệu?",
    "confirmationResetSubtitle": "Bạn có chắc chắn muốn thiết lập lại dữ liệu?",

    "intervalDataTitle": "Dữ liệu khoảng thời gian",
    "feedWarning": "Lượng thức ăn trong bể sắp hết, hãy kiểm tra ngay!",

    "uploadWarning": "Có thay đổi dữ liệu ASTO chưa được tải lên.",
    "uploadData": "Tải dữ liệu",

    "feedDataTitle": "Feed Data",
    "failedConnect": "Không thể kết nối. Chạm để kết nối.",

    "uploadBannerTitle": "Dữ liệu chưa được gửi đến ASTO.",
    "uploadBannerSubtitle": "Tải lên các thay đổi dữ liệu để cập nhật cài đặt trên máy tự động cho ăn.",
    "uploadBannerButton": "GỬI",
    "uploadSuccessTitle": "Tải lên thành công!",
    "uploadSuccessSubtitle": "Cài đặt đã được lưu thành công vào ASTO",
    "sendToAsto": "Gửi đến ASTO",

    "AdvancedSetting": "Cài đặt nâng cao",

    "calibrationTitle": "Nguồn cấp dữ liệu đang hết không như mong đợi?",
    "calibrationButton": "Điều chỉnh luồng cấp liệu",
    "calibrationModalTitle": "Điều chỉnh xả thức ăn",
    "calibrationModalSubtitle": "Nhập dữ liệu theo điều kiện và chúng tôi sẽ điều chỉnh lưu lượng cho lần cho ăn tiếp theo.",
    "calibrationChooseTitle": "Hôm nay, Nguồn cấp dữ liệu của tôi",
    "under": "Kết thúc vào lúc mấy giờ?",
    "over": "Vẫn còn lại",
    "actualEndTime": "Thức ăn hết vào lúc",
    "actualEndTimeAsk": "Kết thúc vào lúc nào?",
    "actualIntervalPeriod": "Thời gian cho ăn đã kết thúc",
    "remainingQuantity": "Ước tính lượng thức ăn còn lại",
    "expectedQuantity": "Tổng lượng thức ăn trước đó",
    "confirmationTitle": "Dữ liệu có đúng không?",
    "confirmationButton": "Có, đúng rồi",
    "changes": "Thay đổi:",
    "debitBefore": "Nợ trước",
    "debitAfter": "Nợ sau",
    "cancelButton": "Quay lại",
    "successTitle": "Lưu thành công!",
    "successSubtitle": "Sẽ có điều chỉnh trong lượt thức ăn tiếp theo.",
    "close": "Đóng"
  },

  "autoFeederPondEditScreen": {
    "title": "Cài đặt Auto-feeder",

    "connection": "Sự liên quan",
    "general": "Tổng quan",
    "normal": "Bình thường",
    "continuous": "Tiếp diễn",
    "misc": "linh tinh",

    "bluetooth": "Bluetooth",
    "wifi": "WiFi",
    "ssid": "SSID",
    "password": "Mật khẩu",

    "mode": "Cách thức",
    "debit": "Nguồn cấp dữ liệu ghi nợ (gr/s)",
    "throwDebit": "Nguồn cấp dữ liệu ghi nợ (gr/throw)",
    "startTime": "Thời gian bắt đầu",
    "endTime": "Thời gian kết thúc",
    "onTime": "Hẹn giờ BẬT (second(s))",

    "timesPerDay": "Số lần mỗi ngày",
    "timesPerPeriod": "Thời gian ném mỗi lần cho ăn",
    "intervalPerPeriod": "khoảng thời gian ném (phút(s))",
    "intervalPeriod": "Thời lượng nguồn cấp dữ liệu (phút(s))",

    "onTimeUnit": "thứ hai",

    "testRun": "Chạy thử nghiệm",
    "clearSetting": "Xóa cài đặt",
    "disconnect": "Ngắt kết nối",
    "delete": "Xóa",

    "connected": "kết nối",
    "disconnected": "ngắt kết nối",
    "connecting": "Đang kết nối...",
    "tapToReconnect": "Nhấn để kết nối lại",
    "tapToConnect": "Nhấn để kết nối",
    "tapToRefresh": "Nhấn để làm mới",

    "failedToConnect": "Kết nối thất bại",

    "uploadBannerTitle": "Dữ liệu chưa được tải lên ASTO",
    "uploadBannerSubtitle": "Tải lên các thay đổi dữ liệu để cập nhật cài đặt trên máy tự động cho ăn.",
    "uploadBannerButton": "Tải lên ASTO",
    "continuousSetting": "Configuración Básica para Modo Continuo",
    "normalSetting": "Configuración Básica para Modo Normal"
  },

  "autoFeederPondActivityListScreen": {
    "title": "Hoạt động nạp tự động",
    "subtitle": "trong vòng một tuần"
  },

  "autoFeederPondForm": {
    "farmId": "Nông trại",
    "pondId": "Ao",
    "id": "TÔI",
    "name": "Tên",
    "mode": "Cách thức",
    "updatedAt": "Cập nhật tại",
    "autoFeeder": "Tự động nạp",

    "farmIdPlaceholder": "Chọn trang trại",
    "pondIdPlaceholder": "Chọn ao",
    "idPlaceholder": "TÔI",
    "namePlaceholder": "Tên",
    "modePlaceholder": "Cách thức",
    "updatedAtPlaceholder": "Cập nhật tại",
    "autoFeederPlaceholder": "Chọn Bộ nạp tự động",

    "enableBluetoothTitle": "Bật Bluetooth",
    "enableBluetoothSubtitle": "Khi Bluetooth được kích hoạt, bạn có thể tiến hành thêm asto vào thiết bị của mình.",
    "enableBluetoothConfirm": "CHO PHÉP",
    "enableBluetoothCancel": "SAU ĐÓ"
  },

  "farmPondListScreen": {
    "header": "Tạo ao",
    "title": "Nhiều ao",
    "lastUpdate": "cập nhật cuối cùng %{datetime}",
    "noUpdate": "Không có dữ liệu được cập nhật trong tuần trước",
    "noRecord": "Không có chu kỳ nào đang hoạt động",
    "number": "Tổng số  ao",
    "pondName": "Tên ao",
    "total": "{{pond}} ao",
    "pondTooltip": "Tạo ao để bạn có thể ghi dữ liệu ra giấy ngay lập tức.",
    "createCycle": "Bắt đầu chu kỳ để tận hưởng các dịch vụ của Jala",

    "initialDataLoading": "Đang Tải Dữ Liệu Ban Đầu"
  },
  "farmAutoFeederPondListScreen": {
    "title": "máy cấp liệu tự động",
    "asto": "Asto",
    "addAsto": "Thêm Asto",
    "astoList": "Danh sách Asto",

    "feed": "Feed: %{feed} kg",
    "noDevices": "Không có thiết bị",
    "mode": "Cách thức: %{mode}",
    "todayFeed": "nguồn cấp dữ liệu hôm nay",
    "lastUpdate": "Cập nhật cuối cùng",
    "lastUploaded": "Tải lên lần cuối",
    "playMode": "chế độ chơi",
    "nextDayFeed": "nguồn cấp dữ liệu ngày hôm sau",

    "farm": "Nông trại",
    "normal": "Bình thường",
    "continuous": "Tiếp diễn",

    "emptyStateTitle": "Bạn chưa thêm Asto",
    "emptyStateSubtitle": "Để sử dụng tính năng này, bạn cần thêm Asto.",
    "emptyStateButton": "Thêm Asto",

    "orderTitle": "Bạn chưa có Asto?",
    "orderButton": "đặt hàng ngay",

    "cycleClosedTitle": "Không có chu kỳ hoạt động",
    "cycleClosedSubtitle": "Bạn cần tạo một chu kỳ mới.",
    "cycleLaterButton": "SAU NÀY",
    "createCycleButton": "TẠO CHU KỲ"
  },
  "measurementCreateScreen": {
    "title": "Thêm dữ liệu"
  },
  "measurementEditScreen": {
    "title": "Chỉnh sửa dữ liệu"
  },

  "createPondForm": {
    "farm": "Tạo ao cho trang trại",
    "prefix": "Tiền tố tên ao",
    "name":"Tên ao",
    "length":"Chiều dài (m)",
    "width":"Bề rộng (m)",
    "wide": "Rộng (m2)",
    "depth": "Chiều sâu (m)",
    "type": "Loại ao",
    "square": "Quảng trường",
    "circle": "Vòng tròn",
    "diameter": "Đường kính (m)",
    "nameError": "Tên đã được sử dụng trong một ao khác",
    "prefixDisclaimer": "Việc đánh số sẽ tự động theo số lượng ao nuôi",
    "inputTitle": "Danh sách ao",
    "inputDisclaimer": "Thay đổi diện tích ao theo thực tế để việc tính toán ước lượng của Jala phù hợp hơn.",

    "namePlaceholder":"Tên ao",
    "lengthPlaceholder":"-",
    "widthPlaceholder":"-",
    "widePlaceholder": "-",
    "depthPlaceholder": "-",
    "diameterPlaceholder": "-",
    "prefixPlaceholder": "Tiền tố tên ao",
  },

  "quickInput": {
    "farming": "Nuôi Tôm",
    "daily": "Hằng ngày",
    "LabTest": "Kiểm tra trong phòng thí nghiệm",
    "Others": "Khác",
    "startCycle": "Bắt đầu chu kỳ",
    "sampling": "Lấy mẫu",
    "harvest": "Thu hoạch & Thu tỉa",
    "closeCycle": "Kết thúc chu kỳ",
    "createFarm": "Tạo Trại nuôi",
    "createPond": "Tạo ao",
    "feed": "Lượng thức ăn",
    "waterQuality": "Chất lượng nước",
    "treatment": "Phòng, trị bệnh",
    "feedingTray": "Nhá/Sàng ăn",
    "chemical": "Hóa học",
    "microbiology": "Vi sinh vật",
    "plankton": "Sinh vật phù du",
    "disease": "Bệnh dịch",
    "mortality": "Số lượng chết",
    "quickInputTitle": "Ghi nhật ký nhanh"
  },

  "phoneInput": {
    "chooseCountry": "Chọn quốc gia"
  },

  "picker": {
    "choose": "lựa chọn"
  },

  "bluetoothPicker": {
    "scanQr": "Quét QRQuét QR"
  },

  "predictions": {
    "activePond": "Ao đang hoạt động",
    "#": "#",
    "biomasPrediction": "Dự đoán sinh khối",
    "feedCumulative": "nguồn cấp dữ liệu tích lũy",
    "SrPrediction": "dự đoán SR",
    "SeliingPricePrediction": "Dự đoán giá trị bán"
  },

  "monitoring": {
    "batch": "Một lô hàng",
    "label": "Chọn Lô hàng",
    "cyclesCount": "Một chu kỳ",
    "disclaimer": "Hoàn thành dữ liệu của bạn để tính toán ước tính trong ứng dụng sát với thực tế hơn. Nếu bạn có bất kỳ vấn đề nào chưa hài lòng về Ứng dụng Jala.",
    "feedback": "Vui lòng phản hồi để chúng tôi có thể cải thiện tốt hơn",
    "weight": "trọng lượng (g)",
    "size": "Kích Cở",
    "totalWeight": "Tổng sản lượng (kg)",
    "harvestAccumulationWeight": "Sản lượng thu hoạch cộng dồn (kg)",
    "adg": "tăng trưởng hàng ngày (g)",
    "feedAccumulation": "Tổng lượng thức ăn (kg)",
    "survivalRate": "Ước tính tỷ lệ sống SR (%)",
    "fcr": "Ước tính FCR",
    "disclaimerMonitoring": "Hoàn thành nguồn cấp dữ liệu và dữ liệu lấy mẫu để ước tính chính xác hơn",
    "disclaimerMonitoringBefore30": "Hoàn thành dữ liệu nguồn cấp dữ liệu để có các ước tính chính xác hơn",
    "seePond": "Xem ao",
    "parameter": "Thông số",
    "actual": "Thực tế (DoC)",
    "pondPopulate": "Dân số nhóm (%)",
    "estimation": "Ước tính hôm nay",
    "empty": "Dữ liệu không tồn tại"
  },

  "samplingInput": {
    "title":"Thêm dữ liệu lấy mẫu",
    "inputTitle": "Lấy mẫu"
  },

  "treatmentInput": {
    "title":"Thêm dữ liệu điều trị"
  },

  "harvestInput": {
    "title":"Thêm dữ liệu thu hoạch",
    "inputTitle": "Thu hoạch"
  },

  "cycleDiseaseInput": {
    "title": "Thêm dữ liệu bệnh tật"
  },

  "chemical": {
    "header": "Químico",
    "date": "Ngày (Số ngày nuôi)",
    "Ammonia": "NH3",
    "Nitrit": "NO2",
    "Alkalinity": "Độ kiềm",
    "more": "Thêm",
    "inputTitle":"Thêm dữ liệu hóa học",
    "changeParam": "Thay đổi danh sách thông số"
  },

  "chemicalForm" : {
    "farmId": "Trại nuôi",
    "pondId": "Ao nuôi",
    "header": "Kiểm tra Hóa học",
    "measuredDate": "Ngày",
    "ammonia": "Amoniac (NH3) (ppm)",
    "nitrit": "Nitrit (NO2) (ppm)",
    "alkalinity": "Độ kiềm (ppm)",
    "ammonium": "Amonium (NH4) (ppm)",
    "nitrat": "Nitrat (NO3) (ppm)",
    "carbonat": "Cacbonat (CO3) (ppm)",
    "bicarbonat": "Carbonat axit (HCO3) (ppm)",
    "hardness": "độ cứng (ppm)",
    "calcium": "Canxi (Ca) (ppm)",
    "magnesium": "Magiê (Mg) (ppm)",
    "phosphate": "Phospho (PO4) (ppm)",
    "tom": "Tổng lượng chất hữu cơ (TOM) (ppm)",
    "orp": "Khả năng giảm oxy hóa (ORP) (ppm)",

    "farmIdPlaceholder":"Chọn trang trại",
    "pondIdPlaceholder": "Chọn ao",
    "measuredDatePlaceholder": "Chọn ngày",
    "ammoniaPlaceholder": "-",
    "nitritPlaceholder": "-",
    "alkalinityPlaceholder": "-",
    "ammoniumPlaceholder": "-",
    "nitratPlaceholder": "-",
    "carbonatPlaceholder": "-",
    "bicarbonatPlaceholder": "-",
    "hardnessPlaceholder": "-",
    "calciumPlaceholder": "-",
    "magnesiumPlaceholder": "-",
    "phosphatePlaceholder": "-",
    "tomPlaceholder": "-",
    "orpPlaceholder": "-"
  },

  "pondProfileForm": {
    "setting": "Cài đặt ao",
    "delete": "Xóa Pond",
    "name": "Tên ao",
    "rfid": "Số RFID (Không bắt buộc)",
    "rfidTitle": "Số RFID",
    "rfidSubtitle": "RFID là thẻ bạn nhận được khi mua Baruno, bên trong thẻ có mã 8 chữ số mà bạn có thể đăng ký để xác định ao.",
    "length": "chiều dài (m)",
    "width": "Bề rộng (m)",
    "diameter": "Đường kính (m)",
    "area":"Diện tích (m2)",
    "Deep": "Sâu (m)",
    "createdAt": "Ngày tạo",
    "feedingTrayCount": "Khay cho ăn",
    "type": "Loại ao",
    "square": "Quảng trường",
    "circle": "Chung quanh",
    "existingName": "Tên này đã được sử dụng trong ao khác của bạn",
    "warning": "Thay đổi diện tích ao nuôi không ảnh hưởng đến các ước tính của chu kỳ hiện tại hoặc các chu kỳ trước đó. Tuy nhiên, nó sẽ ảnh hưởng đến việc tính toán trong chu kỳ tiếp theo.",
    "rfidNotFound": "không có kết quả nào được tìm thấy",
    "rfidLabel": "RFID",
    "success": "Đã lưu dữ liệu thành công",
    "failed": "Không lưu được dữ liệu, vui lòng kiểm tra kết nối internet của bạn và thử lại",
    "editPondDesc": "Thay đổi diện tích ao nuôi không ảnh hưởng đến các ước tính của chu kỳ hiện tại hoặc các chu kỳ trước đó. Tuy nhiên, nó sẽ ảnh hưởng đến việc tính toán trong chu kỳ tiếp theo.",
    "visit": "*Chuyến thăm",

    "namePlaceholder": "Tên ao",
    "rfidPlaceholder": "Nhập 8 chữ cái mã",
    "lengthPlaceholder": "-",
    "widthPlaceholder": "-",
    "areaPlaceholder":"-",
    "DeepPlaceholder": "-",
    "diameterPlaceholder": "-",
    "createdAtPlaceholder": "Chọn ngày",
    "feedingTrayCountPlaceholder": "Chọn khay ăn",

    "deleteModalTitle": "Bạn có chắc chắn muốn xóa Ao không?",
    "deleteModalSubtitle": "Nếu bạn chắc chắn, hãy gõ ",
    "deleteModalSubtitleLast": "để xác nhận ao bạn muốn xóa.",
    "pondNamePlaceholder": "Nhập tên ao",
    "confirmDeleteButton": "CÓ, XÓA",
    "cancelDeleteButton": "HỦY BỎ",
    "modalErrorMessage": "Gõ “{{pond}}”"
  },

  "cycleHistoryScreen": {
    "header": "Lịch sử chu kỳ",
    "days": "ngày",
    "kg": "kg",
    "percent": "%",
    "age": "Số ngày tuổi",
    "harvest": "Thu hoạch",
    "seed": "Con giống",
    "fcr": "FCR",
    "size": "Kích Cở",
    "survival": "Tỷ lệ sống"
  },

  "personalisationScreen": {
    "header": "Cài đặt riêng",
    "PersonalizationTitle": "Đặt hiển thị trang chủ dựa trên mục bạn cần tìm",
    "PersonalizationSubtitle": "Để cài đặt chế độ xem, hãy chọn một hoặc nhiều lựa chọn dưới đây.",
    "button": "Tiếp theo"

  },

  "verificationScreen": {
    "title": "Xác minh số điện thoại của bạn",
    "subtitle": "Kiểm tra số điện thoại {{phone}} của bạn để tìm mã OTP.",
    "subtitleOld": "Giúp chúng tôi xác thực số điện thoại của bạn bằng cách nhập mã OTP mà chúng tôi đã gửi đến {{phone}}",
    "warningOld": "Vui lòng xác minh số điện thoại của bạn trong vòng {{day}} ngày {{hour}} giờ",
    "verificationInfo": "Bạn có thể sử dụng Jala ngay sau khi xác minh số điện thoại của mình",
    "codeVerificationError": "Mã OTP không chính xác hoặc hết hạn",
    "placeholderOTP": "Mã OTP gồm 6 chữ số",
    "resendOTP": "Gửi lại OTP",
    "cantVerify": "Không thể lấy mã OTP?",
    "contactUs": "  Liên hệ chúng tôi",
    "verificationButton": "Nhập mã OTP",
    "inputBeforeExpired": "Nhập mã OTP trong vòng {{seconds}} giây",
    "changePhoneTitle": "Thay đổi số điện thoại",
    "changePhoneSubtitle": "Chúng tôi sẽ gửi một mã OTP mới đến số điện thoại bạn đã nhập bên dưới.",
    "verification": "xác minh",
    "verificationWarning": "Xác minh số điện thoại của bạn trong vòng {{day}} ngày",
    "inputPhoneTitle": "Nhập số điện thoại",
    "inputPhoneSubtitle": "Giúp chúng tôi xác minh tài khoản của bạn, bắt đầu bằng cách nhập số điện thoại của bạn. Mã OTP sẽ được gửi qua SMS.",
    "changeNumberButton": "Thay đổi số điện thoại và gửi lại OTP",
    "verifExpired": "Hoàn tất xác minh để tiếp tục đến trang tổng quan",
    "whatsappMessageVerification": "Please help me verify my phone number {{phoneNumber}}",
    "whatsappMessageVerificationEmail": "Please help me verify my email {{email}}",
    "changePhone": "Thay đổi điện thoại",
    "phoneVerificationTitle": "Xác minh điện thoại",
    "phoneChangeTitle": "đổi điện thoại",

    "phoneWarning": "Không thể thay đổi số vì nó đã được thay đổi trong 24 giờ qua",
    "phoneError": "Số điện thoại không hợp lệ",
    "phoneDisclaimer": "Bạn chỉ có thể thay đổi số của mình một lần trong 24 giờ. Liên hệ với chúng tôi cho các câu hỏi khác.",

    "verificationFailed": "Xác minh không hoàn thành",
    "OTPLimited": "Không lấy được OTP\nSử dụng số điện thoại khác hoặc Liên hệ với chúng tôi."
  },

  "infoAppScreen": {
    "title": "Thông tin ứng dụng",
    "header": "Ứng dụng quản lý nuôi tôm",
    "thanks": "Cảm ơn bạn đã dùng thử ứng dụng",
    "madeIn": "Made in Indonesia",
    "credit": "© 2022 PT JALA Akuakultur Lestari Alamku"
  },

  ...components,
  ...forms,
  ...screens,
  ...models,
  ...commons,
  yup,

  "privacyPolicy": "Chính sách bảo mật",

  "thunderStorm": "Giông sét",
  "rain": "Mưa",
  "drizzle": "Mưa phùn",
  "cloudy": "Nhiều mây",
  "sunnyCloudy": "Trời nắng nhiều mây",
  "sunny": "Nắng",
  "scorching": "Nóng nực",
  "none": "None",

  "yellow": "Vàng",
  "yellowGreen": "Vàng lục",
  "brown": "Màu nâu",
  "brownGreen": "Nâu lục",
  "darkBrown": "Nâu sẫm",
  "lightBrown": "Nâu nhạt",
  "brownRed": "Nâu đỏ",
  "green": "Xanh lá cây",
  "greenBrown": "Xanh nâu",
  "greenBlue": "Xanh lam",
  "darkGreenBrown": "Xanh nâu đậm",
  "darkGreen": "Xanh lá đậm",
  "black": "Màu đen",

  "Search": "Tìm kiếm",
  "Clear": "xa lạ",
  "Close": "Đóng",
  "Finished": "Hoàn thành",
  "Please Wait": "Vui lòng chờ",
  "Network Error": "Lỗi mạng",
  "language": "Ngôn ngữ",
  "total": "Tổng lượng",
  "average": "Average",
  "million": "Million",
  "millionPerKg": "/kg",
  "doc": "Số ngày nuôi",
  "Today": "Hôm nay",
  "SRWithPercent": "tỷ lệ sống(%)",
  "Size": "Kích Cở",
  "Biomass": "Sản lượng",
  "harvest": "Harvest",
  "cycle": "Một chu kỳ",
  "date": "Số gày nuôi",
  "time": "Thời gian",
  "noPond": "Chưa có ao nào",
  "save": "Lưu",
  "connect": "Connect",
  "add": "cộng",
  "edit": "Chỉnh Sửa",
  "delete": "Xóa",
  "cancel": "Hủy bỏ",
  "failed": "Không thành công",
  "success": "Thành công",
  "upload": "Tải lên",
  "uploading": "Đang tải lên",
  "override": "Override",
  "offlineModeContent": "Dữ liệu được lưu trữ tạm thời trên thiết bị của bạn. Tải lên dữ liệu ngay lập tức khi đủ tín hiệu.",
  "offlineModeWeakConnection": "Kết nối yếu",
  "Errors": "Lỗi",
  "reset": "Cài đặt lại",
  "farmingSummary": "Tóm tắt thông tin nuôi trồng",
  "cycleHistory": "Lịch sử chu kỳ",
  "pondProfile": "Cài đặt ao",
  "cycleProfile": "Cài đặt chu kỳ",
  "searchPondPlaceholder": "Tìm ao...",
  "paramTooltip": "Nhấp vào đây để nhập một tham số dữ liệu khác",

  "and": "và",
  "noData": "không có dữ liệu",

  "areYouSureYouWantTo": "Bạn có chắc chắn muốn làm %{something}?",

  "LongNet": "Net (Tổng số giống bạn đã đặt hàng)",
  "LongGross": "Gross (Tổng số giống nhận được từ trại giống)",
  "LongActual": "Thực tế (Tổng số giống thực tế nhận)",

  "Net": "Số giống đã đặt",
  "Gross": "Tổng số giống nhận được từ trại giống",
  "Actual": "Tổng số giống thực tế nhận được sau khi kiểm tra mẫu",

  "cantBeZero": "Không được bằng 0",
  "validationInput": "Thông tin này này không được để trống",
  "otherParameters": "Các thông số khác",
  "minPassword": "Mật khẩu phải ít nhất 6 kí tự",
  "cantBeMinus": "Đầu vào không được nhỏ hơn 0",

  "filter": "Lọc",
  "addNote": "ghi chú",

  "now": "Hiện nay",

  "fetchingData": "Đang tìm nạp dữ liệu...",
  "offline": "Lưu giữ Dữ liệu ngoại tuyến",

  "changeLanguage": {
    "title": "Lựa chọn ngôn ngữ",
    "Indonesia": "Bahasa Indonesia (ID)",
    "english": "English (EN)",
    "vietnamese": "Tiếng Việt (VN)",
    "espanol": "Español (ES)"
  },

  "checkLink": "Kiểm tra liên kết sau: {{url}}",
  "shareDiseaseTitle": "Thông tin về bệnh tôm: {{disease}}",
  "failedShared": "Không thể truyền dữ liệu, vui lòng thử lại sau",
  "shareNewsTitle": "Bạn đã đọc bài viết này của Jala chưa? {{news}}.",
  "sharePriceTitle": "Cập nhật {{date}}, Giá tôm cỡ 100 con - {{region}}.",
  "copiedToClipboard": "Sao chép vào clipboard",

  "posts": {
    "read_complete_article_only_on": "chỉ đọc toàn bộ bài báo tại"
  },

  "notifications": {
    "infoHeader": "Giá tôm",
    "farmingHeader": "Nông nghiệp",
    "priceNotificationTitle": "Giá tôm mới trong vùng",
    "readAll": "đánh dấu tất cả như đã đọc",
    "waitingForLoad": "Đang tải thông báo mới",
    "emptyNotification": "Thông báo mới trống",
    "refreshPage": "Làm mới trang",
  },

  "NewFeature": "Tính năng mới! {{featureName}}",
  "AlertFailedTitle": "Không thành công",
  "AlertFailedAuthSubtitle": "Đăng nhập không thành công",
  "AlertFailedRegisSubtitle": "Đăng ký không thành công",
  "AlertWrongInput": "Email hoặc mật khẩu không hợp lệ",
  "AlertServerUnreachable": "Không thể kết nối với máy chủ",
  "AlertServerFail": "Xin lỗi vì kết nối với máy chủ bị lỗi",
  "AlertUserNotFound": "Không tìm thấy người dùng, hãy đảm bảo email hay mật khẩu của bạn là đúng",
  "AlertUserUnauthenticated": "Không tìm thấy tên người dùng, vui lòng đăng ký hoặc đăng nhập lại",
  "AppleSignInNotSupported": "Xin lỗi, phiên bản iOs của bạn không thể đăng nhập bằng ID Apple. Vui lòng cập nhật phiên bản iOs của bạn hoặc đăng nhập bằng tùy chọn khác",

}
